// src/hooks/useErrorHandler.js
import { useState, useCallback } from 'react';

/**
 * Centralized error handling hook for contexts
 * Provides consistent error state management and async operation handling
 */
export const useErrorHandler = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleAsync = useCallback(async (asyncFn) => {
    try {
      setLoading(true);
      setError(null);
      return await asyncFn();
    } catch (err) {
      const errorMessage = err.message || 'An unexpected error occurred';
      setError(errorMessage);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const clearError = useCallback(() => setError(null), []);

  const setErrorState = useCallback((errorMessage) => setError(errorMessage), []);

  return { 
    error, 
    loading, 
    handleAsync, 
    clearError, 
    setErrorState 
  };
};